import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const strip = (Tag, cls) => ({ node, ...p }) => <Tag className={cls} {...p} />; // eslint-disable-line react/prop-types
const C = {
  table: strip('table', 'my-2 w-full border-collapse text-xs'),
  th: strip('th', 'border border-slate-700 bg-slate-800 px-2 py-1 text-left font-semibold text-white'),
  td: strip('td', 'border border-slate-700 px-2 py-1 align-top'),
  h1: strip('h3', 'text-lg font-bold text-white mt-4 mb-2'),
  h2: strip('h3', 'text-base font-bold text-white mt-4 mb-2'),
  h3: strip('h4', 'text-sm font-semibold text-white mt-3 mb-1'),
  p: strip('p', 'mb-2 leading-relaxed'),
  ul: strip('ul', 'list-disc pl-5 mb-2 space-y-1'),
  ol: strip('ol', 'list-decimal pl-5 mb-2 space-y-1'),
  strong: strip('strong', 'text-white font-semibold'),
  hr: () => <hr className="my-3 border-slate-700" />,
  a: ({ node, ...p }) => <a className="text-cyan-400 underline" target="_blank" rel="noreferrer" {...p} />, // eslint-disable-line react/prop-types
};

export const MarkdownText = ({ children, className = '', ...rest }) => (
  <div className={className} {...rest}><ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{children || ''}</ReactMarkdown></div>
);
